import { createContext, useContext } from 'react';

import { DEFAULT_ROOT_NODE_NAME } from '../constants.js';
import type { RootNode } from '../types/guards/node-guards.js';

const defaultData = {
  children: [],
  name: '',
  value: 0,
  id: DEFAULT_ROOT_NODE_NAME,
};

interface TreeMapAggregationData {
  dataForRendering: RootNode;
  dataForHighlighting: RootNode;
}

export const TreeMapAggregationDataContext =
  createContext<TreeMapAggregationData>({
    dataForRendering: defaultData,
    dataForHighlighting: defaultData,
  });

export const useTreeMapAggregationData = () =>
  useContext(TreeMapAggregationDataContext);

TreeMapAggregationDataContext['displayName'] = 'TreeMapAggregationDataContext';
